import { useEffect, useState } from 'react';
import React from 'react';
import './debate.css';
// import bt_orange from '../../../assets/imgs/nuevo_libro/bt_orange.png'


import fram1 from '../../../assets/img/debate1.png'
import imgplay from '../../../assets/img/Play.svg'
import fram2 from '../../../assets/img/debate2.png'
import fram3 from '../../../assets/img/debate3.png'

import estrell from '../../../assets/imgs/detalle_blog/estrell.png'
import { useTranslation } from "react-i18next";

import VideoPopup from '../../popup/videopopup';

const Debate = () => {
    const [over, setOver] = useState(true);
    const [over2, setOver2] = useState(false);
    const [over3, setOver3] = useState(false);

    // const img1 = 'https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/Play.svg';

    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("librBlanc");

    const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);
    const [currentVideoId, setCurrentVideoId] = useState(null);

    const openVideoPopup = (videoId) => {
        setCurrentVideoId(videoId);
        setVideoPopupOpen(true);
      };
    
      const closeVideoPopup = () => {
        setVideoPopupOpen(false);
      };

      const [qty, setQty] = useState(1);
      const initial = 1;
      const max = 3;
      const nextCard = (num) => {
          if ((qty+num) < initial) {
              setQty(initial);            
          }else if ((qty+num) < max) {
              setQty(qty + num);
          } else {
              setQty(max);            
          }
          switch (qty+num) {
              case 1:
                  setOver(true);
                  setOver2(false);
                  setOver3(false);
                  break;
              case 2:
                  setOver2(true);
                  setOver(false);
                  setOver3(false);
                  break;
              case 3:
                  setOver3(true);
                  setOver2(false);
                  setOver(false);
                  break;
          }
      };

    return (
        <div class="contene_debate">
            <VideoPopup  isOpen={isVideoPopupOpen} onClose={closeVideoPopup} videoURL={currentVideoId} />
            <div  className='titulo'>
                <div class="NL_tit_debate"><h1><i>{(t('header.tituDebate1'))}</i>{(t('header.tituDebate2'))}{(t('header.tituDebate3'))}</h1></div>
            </div>
            <div className='NL_debate'>

                <div id='NL_card1' className={over ? 'active NL_recomendado_card fadeIn animated' : 'NL_recomendado_card'} >

                        <img class="NL_recomendado_img1" src={fram1} onClick={() => openVideoPopup('https://www.youtube.com/embed/Y4H5Sn5lfJI?si=KCB4F-jEd-OhOHWh')} />
                        <img class="NL_recomendado_img_play" onClick={() => openVideoPopup('https://www.youtube.com/embed/Y4H5Sn5lfJI?si=KCB4F-jEd-OhOHWh')} src={imgplay} />
                        
                    <div class="NL_recomendados_txt">
                        <p class="debate">{(t('header.tituDebat1'))}<br/>
                        {(t('header.tituDebat12'))}
                        </p>
                      <p class="debate_desc"> {(t('header.descDebat1'))}  
                        </p >
                    </div>

                </div>
                <div id='NL_card2' className={over2 ? 'active NL_recomendado_card fadeIn animated' : 'NL_recomendado_card'}  >

                        <img class="NL_recomendado_img1" src={fram2} onClick={() => openVideoPopup('https://www.youtube.com/embed/8D50sP-CHw8?si=H31IoAROU2_OI4RV')}  />
                        <img class="NL_recomendado_img_play" onClick={() => openVideoPopup('https://www.youtube.com/embed/8D50sP-CHw8?si=H31IoAROU2_OI4RV')} src={imgplay} />
                    <div class="NL_recomendados_txt">
                        <p class="debate">{(t('header.tituDebat2'))}<br/>
                        {(t('header.tituDebat22'))}
                        </p>
                        <p class="debate_desc">{(t('header.descDebat2'))}</p>
                    </div>
                </div>
                <div id='NL_card3' className={over3 ? 'active NL_recomendado_card fadeIn animated' : 'NL_recomendado_card'}>

                        <img class="NL_recomendado_img1" src={fram3}  onClick={() => openVideoPopup('https://www.youtube.com/embed/oa2DF2y0OVU?si=b04X7tz-Txisbchg')} />
                        <img class="NL_recomendado_img_play" onClick={() => openVideoPopup('https://www.youtube.com/embed/oa2DF2y0OVU?si=b04X7tz-Txisbchg')} src={imgplay} />
                    <div class="NL_recomendados_txt">
                        <p class="debate">{(t('header.tituDebat3'))} <br/>
                        {(t('header.tituDebat32'))}
                        </p>
                        <p  class="debate_desc">
                            {(t('header.descDebat3'))}</p>
                    </div>
                </div>
                <div class="NL_coment_arrows_movil">
                    <a onClick={() => nextCard(-1)}>
                        <img class="NL_coment_show_arrowL_movil" src='/assets/imgs/detalle_blog/arrow.png'/>
                    </a>
                    <a onClick={() => nextCard(+1)}>
                        <img class="NL_coment_show_arrowL_movil" src='/assets/imgs/detalle_blog/arrow.png'/>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Debate
